import { useState } from 'react'
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { meQuery } from '../lib/queries'
import { ApiError } from '../lib/api'
import { useRealtime } from '../lib/realtime'
import { Sidebar, Topbar } from '../components/shell'

// Staff console layout. Guards the whole subtree: signed out → /login, people without staff access → their portal.
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    try {
      const me = await context.queryClient.ensureQueryData(meQuery)
      if (!me.business) throw redirect({ to: '/portal' })
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) throw redirect({ to: '/login', search: { next: location.href } })
      throw e
    }
  },
  component: AppLayout,
})

function AppLayout() {
  const [menu, setMenu] = useState(false)
  const live = useRealtime()
  return (
    <div className="flex min-h-dvh">
      <Sidebar open={menu} onClose={() => setMenu(false)} />
      <div className="min-w-0 flex-1">
        <Topbar onMenu={() => setMenu(true)} live={live} />
        <main className="px-4 pt-6 pb-16 sm:px-6 lg:px-10">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
